export default "__VITE_ASSET__DbywkrgM__"